import { createContext, useContext } from 'react';

import { PieChartData } from '../types/pie-chart.config.js';

// oxlint-disable-next-line typescript/no-deprecated
export type PieRawDataContext = PieChartData;

export const PieChartRawDataContext = createContext<PieRawDataContext>({
  slices: [],
});

export const usePieChartRawData = () => useContext(PieChartRawDataContext);
